import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { CrimpCloudPartnerService } from 'src/app/shared/services/crimp-cloud-partners/crimp-cloud-partner.service';
import * as fromCrimpCloudPartner from './crimp-cloud-partners.actions';
import { serviceError } from 'src/app/shared/models/serviceError';

@Injectable()
export class CrimpCloudPartnerEffects {
  constructor(
    private actions$: Actions,
    private crimpCloudPartnerService: CrimpCloudPartnerService
  ) { }

  listCrimpCloudPartners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromCrimpCloudPartner.CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS),
      map((action: fromCrimpCloudPartner.ListCrimpCloudPartners) => action.payload),
      mergeMap((payload) =>
        this.crimpCloudPartnerService.listCrimpCloudPartners(payload).pipe(
          map((data) => {
            return new fromCrimpCloudPartner.ListCrimpCloudPartnersSuccess(data);
          }),
          catchError((error) => {
            if (error.status === 401) {
              return EMPTY;
            }
            return of(
              new fromCrimpCloudPartner.ListCrimpCloudPartnersFailed({})
            );
          })
        )
      )
    )
  );

  createCrimpCloudPartner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromCrimpCloudPartner.CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS),
      map((action: fromCrimpCloudPartner.CreateCrimpCloudPartners) => action.payload),
      mergeMap((partnerData) =>
        this.crimpCloudPartnerService.createCrimpCloudPartners(partnerData).pipe(
          map((data) => {
            return new fromCrimpCloudPartner.CreateCrimpCloudPartnersSuccess(data);
          }),
          catchError((error) => {
            console.log(error)
            return of(
              new fromCrimpCloudPartner.CreateCrimpCloudPartnersFailed({
                code: error.response.data.code,
                message: error.response.data.message,
                error: error.response.data.error,
              } as serviceError)
            );
          })
        )
      )
    )
  );

  deleteCrimpCloudPartner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromCrimpCloudPartner.CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS),
      map((action: fromCrimpCloudPartner.DeleteCrimpCloudPartners) => action.payload),
      mergeMap((payload) =>
        this.crimpCloudPartnerService.deleteCrimpCloudPartner(payload).pipe(
          map((data) => {
            return new fromCrimpCloudPartner.DeleteCrimpCloudPartnersSuccess(payload.crimp_cloud_partners);
          }),
          catchError((error) => {
            return of(
              new fromCrimpCloudPartner.DeleteCrimpCloudPartnersFailed({
                code: error.response.data.code,
                message: error.response.data.message,
                error: error.response.data.error,
              } as serviceError)
            );
          })
        )
      )
    )
  );

  listLoggedInCrimpCloudPartners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromCrimpCloudPartner.CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY),
      map((action: fromCrimpCloudPartner.ListCrimpCloudPartners) => action.payload),
      mergeMap((payload) =>
        this.crimpCloudPartnerService.listCrimpCloudPartners(payload).pipe(
          map((data) => {
            return new fromCrimpCloudPartner.ListLoggedInPartnerCompanySuccess(data);
          }),
          catchError((error) => {
            return of(
              new fromCrimpCloudPartner.ListLoggedInPartnerCompanyFailed({})
            );
          })
        )
      )
    )
  );

}
